<template>
  <v-card :elevation="1" rounded="lg"
          style="height:100%; width:100%; background-color:white" class="d-flex flex-column ">
    <div class="d-flex flex-row justify-space-between pl-5 pt-5 pr-5 mb-4">
      <div class="font-weight-bold text-lg">
        <span>{{ this.conf.title }}</span>
      </div>
    </div>
    <div class="table-container overflow-hidden">
      <v-data-table
          :headers="headers"
          :items="rowData"
          fixed-header
          hide-default-footer
          disable-pagination
          class="flex-table scrollbox"
      >

        <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item }">
          <div v-bind:key="header.date">
          <span v-if="header.value == 'rate'" style="cursor:pointer"
          >{{ getPercentage(item.nbRepeater, item.totalBooking) }}</span>
            <span v-else style="cursor:pointer">{{ item[header.value] }}</span>
          </div>

        </template>


      </v-data-table>
      <smart-dialog :title="idsDialog.title"
                    v-model="idsDialog.open"
      >
        <v-row class="pa-4">
          <v-col cols="2" v-for="id in ids" :key="id.id">

            <v-chip
                class=""
                small
                label
                outlined
                @click="toBookingUrl(id.id)"
            >
              {{ id.id }}
              <v-icon x-small class="ml-2" l>open_in_new</v-icon>
            </v-chip>
          </v-col>
        </v-row>
      </smart-dialog>
    </div>
  </v-card>
</template>
<script>
import {EventBus} from "@/components/commons/event-bus";
import {post} from "@/utils/api";

export default {
  name: "RepeaterZilMauriceTable",
  props: {
    form: {type: Object, required: true},
    conf: {type: Object, required: false, default: null}
  },
  data() {
    return {
      url: `/api/widget/dashboard/repeater/site/rate`,
      data: null,
      loading: true,
      idsDialog: {
        open: false,
        title: ""
      },
      searchForm: null,
      ids: [],
      headers: [
        {
          text: 'Année',
          align: 'start',
          sortable: false,
          value: 'year',
          date: "1970-01-01"
        },
        {
          text: 'Nb Repeater',
          align: 'start',
          sortable: false,
          value: 'nbRepeater',
          date: "1970-01-01"
        },
        {
          text: 'Total',
          align: 'start',
          sortable: false,
          value: 'totalBooking',
          date: "1970-01-01"
        },
        {
          text: 'Ratio',
          align: 'start',
          sortable: false,
          value: 'rate',
          date: "1970-01-01"
        },
      ],
      rowData: [],
    }
  },
  created() {
    EventBus.$on('searchDashboard', () => this.init());
    this.init();
  },
  methods: {
    init() {
      this.reset()
      this.searchForm = this._formatPayloadWidgetDashboard(this.conf, this.form)
      this.searchForm.sites = ["ZilMaurice"]
      post(this.url, this.searchForm, {
        "Content-Type": "application/json",
      }).json((r) => {
        this.rowData = r
      })

    },
    reset() {
      this.headers = [{
        text: 'Année',
        align: 'start',
        sortable: false,
        value: 'year',
        date: "1970-01-01"
      },
        {
          text: 'Nb Repeater',
          align: 'start',
          sortable: false,
          value: 'nbRepeater',
          date: "1970-01-01"
        },
        {
          text: 'Total',
          align: 'start',
          sortable: false,
          value: 'totalBooking',
          date: "1970-01-01"
        },
        {
          text: 'Ratio',
          align: 'start',
          sortable: false,
          value: 'rate',
          date: "1970-01-01"
        },]
      this.rowData = []
    },
    getPercentage(repeater, total) {

      return this.computePercentage(repeater, total);
    },
    computePercentage(repeater, total) {
      return ((repeater * 100) / (total || 1)).toFixed(2) + " %";
    },

  },
}
</script>
<style scoped>
.table-container {
  display: flex;
  margin-top: 20px;
  flex-grow: 1;
  overflow-y: hidden;
  overflow-x: hidden;

}

.flex-table {
  overflow-y: scroll;
  width: 100%;
}

.flex-table > div {
  width: 100%;
}

</style>